document.addEventListener('DOMContentLoaded', function() {
    const sellingPlanOptions = document.querySelectorAll('.selling-plan-option input[type="radio"]');
    const hiddenInput = document.getElementById('selling-plan-input');
    
    sellingPlanOptions.forEach(option => {
      option.addEventListener('change', function() {
        document.querySelectorAll('.selling-plan-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        this.closest('.selling-plan-option').classList.add('selected');
        hiddenInput.value = this.value;
      });
    });
  });


  // Hilfsfunktion zum Formatieren von Preisen
function bdFormatMoney(cents) {
  var settings = (window.themeVariables && window.themeVariables.settings) || {};
  var amount = (cents / 100).toFixed(2);
  var sep = settings.currencyDecimalSeparator || ',';
  if (sep !== '.') {
    amount = amount.replace('.', sep);
  }
  var symbol = settings.currencySymbol || '€';
  var position = settings.currencyPosition || 'suffix';
  return position === 'prefix' ? (symbol + ' ' + amount) : (amount + ' ' + symbol);
}

document.addEventListener('variant:change', function(event) {
  var variant = event.detail && event.detail.variant;
  if (!variant) return;

  var form = event.target;
  if (!form) return;

  var product = form.closest('.product');
  if (!product) return;

  var priceContainer = product.querySelector('.selling-plan-price');
  if (!priceContainer) return;

  var html = '';
  html += '<div class="selling-plan-price-row">';

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    html += '<span class="price-amount price-pill">';
    html += bdFormatMoney(variant.price);
    html += '</span>';

    html += '<span class="price-compare"><s>';
    html += bdFormatMoney(variant.compare_at_price);
    html += '</s></span>';
  } else {
    html += '<span class="price-amount">';
    html += bdFormatMoney(variant.price);
    html += '</span>';
  }

  html += '</div>';

  if (variant.unit_price && variant.unit_price_measurement) {
    var m = variant.unit_price_measurement;
    var refValue = m.reference_value || 1;

    html += '<span class="price-unit">';
    html += '(' + bdFormatMoney(variant.unit_price) + '/ ' + refValue + m.reference_unit + ')';
    html += '</span>';
  }

  priceContainer.innerHTML = html;
});